(function() {
    /** @ngInject */
    function waCalendar(Today){
        var Calendar = function(config){
            if(_.isUndefined(config)) config = {};
            var dd = config.date || moment().format("YYYY-MM-DD");
            this.max_month_diff = config.max_month_diff || 0;
            this.setToday(config.date);
            this._date = null;
            this.disabled_days = config.disabled_days || [];

            //console.log(Today);
        };
        Calendar.prototype.setToday = function(date){
            this.date = moment.tgz(date);
            this._date = moment.tgz(this.date);
            this.dates = [];
            this.mode = 'D';
            this.setDates();
        };
        Calendar.prototype.setDisabledDays = function(days){
            this.disabled_days = days;
        };
        Calendar.prototype.isPastMonth = function(){
            return !(Today.isSame(this.date) || Today.isBefore(this.date));
        };
        Calendar.prototype.isDisabledMonth = function(date){
            if(this.max_month_diff === 0) return true;
        };
        Calendar.prototype.isFutureMonthAllowed = function(step){
            if(this.max_month_diff === 0) return true;
            var cm = moment([Today.get('year'), Today.get('month'), 1]).add(this.max_month_diff, "months");
            var nm = moment([this.date.get('year'), this.date.get('month'), 1]);
            step = _.isUndefined(step) ? +1 : step;
            if(step > 0)
                nm.add(1, "month");
            else
                nm.subtract(1, "month");
            return nm.isSame(cm) || nm.isBefore(cm);
        };
        Calendar.prototype.getMonths = function(){
            return moment.months();
        };
        Calendar.prototype.getDays = function(){
            var days = _.clone(moment.weekdaysShort());
            var sunday = days.shift();
            days.push(sunday);
            return days;
        };
        Calendar.prototype.getYears = function(){
            return _.range(this.date.get("year")-10,this.date.get("year")+10);
        };
        Calendar.prototype.stepDate = function(step, what){
            if(what == 'M') {
                if (step < 0 && this.isPastMonth()) return false;
                if(!this.isFutureMonthAllowed(step)) return false;
            }
            if(step >= 0)
                this.date.add(Math.abs(step),what);
            else
                this.date.subtract(Math.abs(step),what);
            if(this.mode == 'D') this.setDates();
            return true;
        };
        Calendar.prototype.isToday = function(x){
            if(_.isNull(this._date)) return false;
            return x.isSame(moment().format('YYYY-MM-DD'));
        };
        Calendar.prototype.isActive = function(day){
            if(_.isNull(this._date)) return false;
            return this._date.format('YYYY-MM-DD') === day.format('YYYY-MM-DD');
        };
        Calendar.prototype.isActiveDate = function(day,date) {
            if(_.isNull(day) || _.isNull(date)) return false;
            return this.date.isSame(date,'month') && day.format('YYYY-MM-DD') === date.format('YYYY-MM-DD');
        };
        Calendar.prototype.setDates = function(){
            var _dates = [];
            this.mode = 'D';
            this.date.date(1);
            var totalDays = this.date.daysInMonth();
            var firstday = this.date.isoWeekday();
            var month_num = this.date.month();
            //console.log(this.date);
            var dup_date = moment(this.date);

            dup_date.subtract(firstday-1, "day");
            var firstrow = true;
            var d = 0;
            var x = 0;
            var y = 1;
            var loop = true;
            var weekNum = 0;
            while (loop) {
                if(weekNum > 5){
                    loop = false;
                    continue;
                }
                _dates[weekNum] = [];
                for (x = 0; x < 7; x++) {
                    d = x+1;
                    //if (y <= totalDays)
                    if (firstrow) {
                        _dates[weekNum][x] = dup_date.clone();//moment(dup_date);
                        y++;
                    } else {
                        _dates[weekNum][x] = dup_date.clone();//moment(dup_date);
                        y++;
                    }
                    dup_date.add(1,"day");
                }
                if(dup_date.month() > month_num) loop = false;
                firstrow = false;
                weekNum++;
            }

            this.dates = _dates;
            return true;
        };
        Calendar.prototype.isDisabled = function(day){
            if(!moment.isMoment(day)) return true;
            if(day.month() < moment().month() && day.year() < moment().year()) return true;
            var dd = day.format('YYYY-MM-DD'); //this.date.format("YYYY-MM") + "-" + day;
            if(this.isToday(day)) return false;
            if(Today.format("YYYY-MM-DD") === dd) return false;
            if(Today.isSame(dd)) return false;
            if(Today.isBefore(dd)) return false;
            return true;
        };
        Calendar.prototype.isOffDay = function(day){
            //if(_.isEmpty(WidgetData.off_days)) return false;
            if(!moment.isMoment(day)) return true;
            if(day == '') return true;
            var full_day = day.format('YYYY-MM-DD'); //this.date.format("YYYY-MM") + "-" + day;
            if(_.has(this.disabled_days,full_day))
                return this.disabled_days[full_day] == 0 ? true : false;
            return true;
            //return _.includes(WidgetData.off_days, this.date.format("YYYY-MM") + "-" + day);
        };
        Calendar.prototype.getDate = function(day){
            if(!moment.isMoment(day)) return true;
            if(day == '') return false;
            return day.format('YYYY-MM-DD');
        };
        Calendar.prototype.isNotSameMonth = function(d){
            if(d){
                return d.month() !== this.date.month();
            }else{
                return true;
            }
        };
        return Calendar;
    }
    angular.module("Waiteraid").factory("waCalendar", waCalendar);
})();
